export const state = {
    reports: [],
    fileopeneddates: [],
    data: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/reports/state.js